'use client'

import React from 'react'
import { Container, Grid } from '@quark/layout'
import { Text } from '@quark/typography'
import { Reveal } from '@quark/animation'
import AckoLogo from '@public/images/enterprise/ACKO-Horizontal.svg'
import Tick from '@public/images/enterprise/purple-tick.svg'
import Cross from '@public/images/enterprise/close.svg'
import styles from './comparisonSection.module.scss'

interface ComparisonSectionProps {
  title?: string
  subtitle?: string
  comparisonTableData?: {
    featureList?: Array<{
      id?: string
      value?: string
    }>
    otherValues?: string[]
    ackoValues?: string[]
  }
}

const ComparisonSection = (data: ComparisonSectionProps) => {
  const comparisonTableData = data?.comparisonTableData

  return (
    <Container
      backgroundColor="base/primary"
      type="fluid"
      paddingTop={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}
      paddingBottom={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}
      paddingLeft="spacing-16"
      paddingRight="spacing-16">
      <Container
        type="root"
        backgroundColor="base/secondary"
        padding="spacing-16"
        paddingTop="spacing-40"
        borderRadius="radius-6xl">
        <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 100 }}>
          <Text as="p" fontStyle="um_text-base/normal" color="base/primary" textAlign="center">
            {data?.title}
          </Text>
          <Container paddingTop="spacing-8" paddingBottom="spacing-40">
            <Text
              as="p"
              fontStyle={{ lg: 'um_text-5xl/bold', md: 'um_text-4xl/bold', sm: 'um_text-3xl/bold' }}
              color="base/primary"
              textAlign="center">
              <span dangerouslySetInnerHTML={{ __html: data?.subtitle || '' }} />
            </Text>
          </Container>
        </Reveal>
        <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 200 }}>
          <Container type="max-parent" backgroundColor="base/overlay" borderRadius="radius-4xl" overflow="hidden">
            <Grid gridTemplateColumns="3">
              <div>
                {comparisonTableData?.featureList?.map((feature, index) => (
                  <div
                    className={`${styles.featureItem} ${styles.feature}`}
                    key={index}
                    style={{ visibility: index === 0 ? 'hidden' : 'visible' }}>
                    <Text
                      as="p"
                      fontStyle={{ lg: 'um_text-xl/medium', md: 'um_text-lg/medium', sm: 'um_text-base/medium' }}
                      color="base/primary">
                      {feature?.value}
                    </Text>
                  </div>
                ))}
              </div>
              <div>
                {comparisonTableData?.ackoValues?.map((item: any, index: number) => (
                  <div className={`${styles.featureItem} ${styles.ackoFeature}`} key={index}>
                    {index === 0 ? (
                      <div>
                        <AckoLogo className={`${styles.mobileIcon}`} width={140} height={32} />
                      </div>
                    ) : item?.value ? (
                      <Tick className={`${styles.mobileIcon} ${styles.iconSmall}`} width={48} height={48} />
                    ) : (
                      <Cross className={`${styles.mobileIcon} ${styles.iconSmall}`} width={48} height={48} />
                    )}
                  </div>
                ))}
              </div>
              <div>
                {comparisonTableData?.otherValues?.map((item: any, index: number) => (
                  <div className={styles.featureItem} key={index}>
                    {index === 0 ? (
                      <Text
                        as="p"
                        fontStyle={{ lg: 'um_text-xl/medium', md: 'um_text-lg/medium', sm: 'um_text-base/medium' }}
                        color="base/primary">
                        {item?.value}
                      </Text>
                    ) : item?.value ? (
                      <Tick className={`${styles.mobileIcon} ${styles.iconSmall}`} width={48} height={48} />
                    ) : (
                      <Cross className={`${styles.mobileIcon} ${styles.iconSmall}`} width={48} height={48} />
                    )}
                  </div>
                ))}
              </div>
            </Grid>
          </Container>
        </Reveal>
      </Container>
    </Container>
  )
}

export default ComparisonSection
